import React from 'react';
import { AppView } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import NewsList from '../components/NewsList';
const strings = {
    title: 'News',
};
const StockNewsScreen = withAnimatedNavigationHeader(({ route, onScroll }) => {
    const assetId = route.params?.assetId;
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <NewsList assetId={assetId} onScroll={onScroll}/>
      </AppView>);
}, ({ colors }) => ({
    title: strings.title,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default StockNewsScreen;
